<template>

  <div>
    <div class="w-100 h-100">
      <div class="" v-if="product.price !== null && product.variation ==0">
        <div class="product-price fa-num" v-if="product.offer>0">
          <div class="row px-3 ">

            <div class="col-12 price-now font-size-dynamic-h5 mb-2">
              <span class="px-1 font-weight-light">{{ formatNumber(product.price - product.offer) }}</span>
              <small class="text-center float-left price-font ">
                هــــزار
                <br>
                تـــومان
              </small>
            </div>
            <div class="col-12 ">

              <div>
                <del class="price-old px-2 font-weight-light  ">{{ formatNumber(product.price) }}</del>
                <div class="d-inline text-white percent-btn pl-1">
                  <span class="percent-offer text-center font-weight-light  "> ٪ {{
                      formatNumber(Math.floor((product.offer / product.price) * 100))
                    }}  </span>
                </div>
              </div>


            </div>
          </div>


        </div>
        <div class="product-price fa-num " v-else>
          <div class="col-12 price-now font-size-dynamic-h5 ">
            <span class="px-1 font-weight-light">{{ formatNumber(product.price) }}</span>
            <small class="text-center float-left price-font ">
              هــــزار
              <br>
              تـــومان
            </small>
          </div>


        </div>
      </div>

      <div class="" v-if="product.variation ==1">
        <span class="product-price" v-if="productOfferChecker(product)">

        </span>
        <div class="product-price fa-num">
          <div class="row text-right ">
            <div class="col-12 price-now font-size-dynamic-h5 price-range">
              <span class=" font-weight-light">
                <span class="font-weight-light font-size-dynamic-h6 ">قیمت از: </span>
                {{ (productPriceRange) }} </span>


            </div>
            <div class="col-12 price-now font-size-dynamic-h5 price-range">
              <span class="font-weight-light font-size-dynamic-h6 ">تخفیف از: </span>
              <span class=" font-weight-light">{{ (productOfferRange) }}</span>

            </div>
          </div>

        </div>
      </div>

      <div class="" v-if="product.variation ==2">
        <div class="product-price fa-num">
          <div class="col-12 price-now font-size-dynamic-h5">
            <span class="px-1 font-weight-light">{{ formatNumber(product.min_price) }}</span>
            <small class="text-center float-left price-font ">
              هــــزار
              <br>
              تـــومان
            </small>
          </div>
        </div>
      </div>

      <div class="" v-if="checkProductHaveFormula(product)">
        <div class="product-price fa-num" v-if="product.offer>0">
          <div class="row px-3 ">

            <div class="col-12 price-now font-size-dynamic-h5 mb-2">
              <span class="px-1 font-weight-light">{{ formatNumber(product.price - product.offer) }}</span>
              <small class="text-center float-left price-font ">
                هــــزار
                <br>
                تـــومان
              </small>
            </div>
            <div class="col-12 ">

              <div>
                <del class="price-old px-2  font-weight-light">{{ formatNumber(product.price) }}</del>
                <div class="d-inline text-white percent-btn pl-1">
                  <span class="percent-offer text-center font-weight-light  "> ٪ {{
                      formatNumber(Math.floor((product.offer / product.price) * 100))
                    }}  </span>
                </div>
              </div>


            </div>
          </div>
        </div>
        <div class="product-price fa-num" v-else>
          <div class="col-12 price-now font-size-dynamic-h5">
            <span class="px-1">{{ formatNumber(product.min_price) }}</span>
            <small class="text-center float-left price-font ">
              هــــزار
              <br>
              تـــومان
            </small>
          </div>
        </div>
      </div>


    </div>
  </div>


</template>

<script>
import {formatNumber, flatten} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Converter";
import {
  getProductPriceRange,
  getProductOfferRange,
  productOfferChecker
} from "@moeinmdn/mixitweb-front-modules/src/plugin/Modules/Product";
import {checkProductHaveFormula} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/ShoppingCartFunctions";

export default {
  name: "price",
  props: {
    product: {}
  },
  computed: {
    productPriceRange() {
      return this.getProductPriceRange(this.product)
    },
    productOfferRange() {
      return this.getProductOfferRange(this.product)
    }
  },
  methods: {
    checkProductHaveFormula,
    formatNumber,
    productOfferChecker,
    getProductPriceRange,
    getProductOfferRange,
    flatten,
  },

}
</script>

<style scoped>
.product-price {
  font-size: 15px;
  font-weight: bold !important;
  color: var(--dark) !important;
}

.product-price .price-old {
  color: gray;
}

.product-card.product-card-horizontal .product-card-body .product-price {
  margin-top: 20px;
}

.price-font {
  font-size: 9px;
  margin-top: 2px;

}

.price-old {
  color: gray;

}

.price-now {
  color: black;
}

.font-size-dynamic-h5 {


  font-size: clamp(10px, 5vw, 15px);

}

.percent-offer {
  font-size: clamp(12px, 5vw, 12px);

}

.percent-btn {
  border-radius: 10px;
  background-color: #D32F2F;

}
.font-size-dynamic-h6{

  font-size: clamp(7px, 5vw, 13px);

}

  @media screen and (max-width: 1200px) {
    .price-range{
      translate: 0px -20px;
    }
  }


</style>